import { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import { WorkingIndicator } from 'BMapsUI/ui_utils';

export default function LoadingIconButton({
    Icon, load, children, ...props
}) {
    const [isLoading, setIsLoading] = useState(false);
    const onClick = async () => {
        setIsLoading(true);
        try {
            await load();
        } finally {
            setIsLoading(false);
        }
    };

    return isLoading
        ? <IconButton {...props}><WorkingIndicator /></IconButton>
        : <IconButton onClick={onClick} {...props}><Icon /></IconButton>;
    // Note: if you want to switch to CircularProgress instead of WorkingIndicator,
    // take the CircularProgress out of the IconButton.
}
